import Popconfirm from './popconfirm'
export * from './popconfirm'
export default Popconfirm
